import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import { HelperService } from '../../services/helper.service'

import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  standalone: true,
  imports: [TranslatePipe]
})
export class UploadFileComponent implements OnChanges {
  @Input() uploadedFile: any
  @Output() uploadFile: EventEmitter<any> = new EventEmitter()
  @Output() deleteFile: EventEmitter<any> = new EventEmitter()
  @ViewChild('attachment') attachment: any
  @Input() inputFileId!: string
  public fileInfo: any

  @Input() filesArr!: any[]

  constructor(private helperService: HelperService) {}

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes)
    this.fileInfo = this.uploadedFile
  }

  triggerInput() {
    const input = document.getElementById(this.inputFileId)
    if (input) {
      input.click()
    }
  }

  onFileChanged(event: any) {
    this.fileInfo = event?.target?.files[0]
    this.uploadFile.emit(event?.target?.files[0])
  }

  // handeled from backend
  downLoadFile() {
    this.helperService.downLoadFile(this.fileInfo).subscribe({
      next: (response) => {
        // should download the file after success using create blob function in helper service
        // this.helperService.createBlob(response,`file`);
        const file = new Blob([response], { type: 'application/pdf' })
        const fileURL = URL.createObjectURL(file)
        const a = document.createElement('a')
        a.href = fileURL
        a.target = '_blank'
        a.download = 'attachment.pdf'
        document.body.appendChild(a)
        a.click()
      },
      error: (err: any) => {
        console.error('err is :', err)
      }
    })
  }

  onRemoveFile() {
    this.fileInfo = null
    this.attachment.nativeElement.value = ''
    this.deleteFile.emit(this.inputFileId)
  }

  removeFileFromArr(index: number) {
    this.fileInfo = null
    // this.attachment.nativeElement.value = '';
    this.filesArr.splice(index, 1)
    this.deleteFile.emit(this.filesArr)
  }
}
